import { Table, TableView } from '@tiptap/extension-table';
import { TableCell as TiptapTableCell } from '@tiptap/extension-table-cell';
import { TableHeader as TiptapTableHeader } from '@tiptap/extension-table-header';
import { TableRow as TiptapTableRow } from '@tiptap/extension-table-row';
import type { Node as ProseMirrorNode } from '@tiptap/pm/model';

import { blockIdAttribute } from '../../utils';

const TABLE_CLASS = 'confidence-table';

class ConfidenceTableView extends TableView {
  constructor(node: ProseMirrorNode, cellMinWidth: number) {
    super(node, cellMinWidth);
    this.table.classList.add(TABLE_CLASS);
  }
}

// Export the base extensions with custom configuration
export const TableExtension = Table.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      blockId: blockIdAttribute,
    };
  },

  addOptions() {
    const parentOptions = this.parent?.();
    return {
      ...parentOptions,
      resizable: true,
      renderWrapper: parentOptions?.renderWrapper ?? true,
      handleWidth: parentOptions?.handleWidth ?? 5,
      cellMinWidth: parentOptions?.cellMinWidth ?? 100,
      View: ConfidenceTableView,
      lastColumnResizable: parentOptions?.lastColumnResizable ?? true,
      allowTableNodeSelection: parentOptions?.allowTableNodeSelection ?? true,
      HTMLAttributes: {
        ...(parentOptions?.HTMLAttributes ?? {}),
        class: TABLE_CLASS,
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    const parentClass = this.options.HTMLAttributes?.class ?? '';
    const extraClass = HTMLAttributes?.class ?? '';
    const mergedClass = [parentClass, extraClass].filter(Boolean).join(' ');

    return [
      'table',
      {
        ...this.options.HTMLAttributes,
        ...HTMLAttributes,
        class: mergedClass,
      },
      ['tbody', 0],
    ];
  },
});

export const TableRow = TiptapTableRow.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        ...(this.parent?.().HTMLAttributes ?? {}),
        class: 'confidence-table-row',
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    const parentClass = this.options.HTMLAttributes?.class ?? '';
    const extraClass = HTMLAttributes?.class ?? '';
    const mergedClass = [parentClass, extraClass].filter(Boolean).join(' ');

    return [
      'tr',
      {
        ...this.options.HTMLAttributes,
        ...HTMLAttributes,
        class: mergedClass,
      },
      0,
    ];
  },
});

export const TableHeader = TiptapTableHeader.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        ...(this.parent?.().HTMLAttributes ?? {}),
        class: 'confidence-table-header',
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    const parentClass = this.options.HTMLAttributes?.class ?? '';
    const extraClass = HTMLAttributes?.class ?? '';
    const mergedClass = [parentClass, extraClass].filter(Boolean).join(' ');

    return [
      'th',
      {
        ...this.options.HTMLAttributes,
        ...HTMLAttributes,
        class: mergedClass,
      },
      0,
    ];
  },
});

export const TableCell = TiptapTableCell.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        ...(this.parent?.().HTMLAttributes ?? {}),
        class: 'confidence-table-cell',
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    const parentClass = this.options.HTMLAttributes?.class ?? '';
    const extraClass = HTMLAttributes?.class ?? '';
    const mergedClass = [parentClass, extraClass].filter(Boolean).join(' ');

    return [
      'td',
      {
        ...this.options.HTMLAttributes,
        ...HTMLAttributes,
        class: mergedClass,
      },
      0,
    ];
  },
});
